import { useEffect, useState } from "react"
import { ThemeProviderContext, systemTheme, Theme, ThemeProviderState, Color, colorArray } from "./themeContext"

type ThemeProviderProps = {
  children: React.ReactNode
  defaultTheme?: Theme
  storageThemeKey?: string
  storageThemeColor?: string
}

export function ThemeProvider({
  children,
  defaultTheme = systemTheme,
  storageThemeKey = "vite-ui-theme",
  storageThemeColor = "vite-ui-color"
}: ThemeProviderProps) {
  const [theme, setTheme] = useState<Theme>(
    () => (localStorage.getItem(storageThemeKey) as Theme) || defaultTheme
  )

  const [color, setColor] = useState<Color>(
    () => (localStorage.getItem(storageThemeColor) as Color) || 'default'
  )

  useEffect(() => {
    const root = window.document.documentElement
    root.classList.remove("light", "dark")
    root.classList.add(theme)

    colorArray.forEach(color => {
      root.classList.remove(color)
    })
    root.classList.add(color)
  }, [theme, color])

  const value: ThemeProviderState = {
    theme,
    color,
    toogleTheme: () => {
      const newTheme = theme === "dark" ? "light" : "dark"
      localStorage.setItem(storageThemeKey, newTheme)
      setTheme(newTheme)
    },
    toogleColor: (color: Color) => {
      localStorage.setItem(storageThemeColor, color)
      setColor(color)
    }
  }

  return (
    <ThemeProviderContext.Provider value={value}>
      {children}
    </ThemeProviderContext.Provider>
  )
}
